'use client';
import styled from 'styled-components';

export const CopyrightLabel = styled.div`
  font-size: 14px;
  flex: 1;

  ${({ theme }) => theme.mediaQueries.LARGE_1X_UP} {
    margin-left: 8px;
  }
`;

export const ImageWrapper = styled.div`
  flex: 0.5;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 20px;

  ${({ theme }) => theme.mediaQueries.LARGE_1X_UP} {
    flex-direction: row;
    gap: 5px;
  }
`;

export const Logo = styled.div`
  flex: 0.3;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  ${({ theme }) => theme.mediaQueries.LARGE_1X_UP} {
    flex-direction: row;
  }
`;

export const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  flex: 0.5;
  flex-direction: column;
  row-gap: 20px;

  ${({ theme }) => theme.mediaQueries.LARGE_1X_UP} {
    flex-direction: row;
  }
`;
export const StyledText = styled.div`
  font-size: 13px;
  flex: 0.5;

  border-top: 1px solid #f2f2f2;
  padding: 37px 0;
`;
